module.exports = __webpack_public_path__ + "static/media/MyriadPro-BoldCond-01.93a5655a.svg";